import { useCallback } from "react";
import * as R from "ramda";

import { useSession } from "contexts/session";
import resourceOperations from "queries/resourceOperations";

const operation = resourceOperations({
  basePath: "/api/applicants",
  baseKey: "users",
  dataKey: "user",
});

export const useUpdateUser = (id: number, { onSuccess = R.T, ...opts } = {}) => {
  const {
    query: { invalidate: invalidateSession },
  } = useSession();
  return operation.useUpdate(id, {
    ...opts,
    async onSuccess(updatedUser) {
      await invalidateSession("useUpdateUser");
      return onSuccess(updatedUser);
    },
  });
};

export const useUpdatePassword = (id: number, opts = {}) =>
  operation.useUpdate([id, "update_password"], opts);

export const useAcceptTermsAndConditions = (userId: number, opts = {}) => {
  const { mutateAsync } = useUpdateUser(userId, opts);

  return useCallback(async () => {
    await mutateAsync({ terms_and_conditions: true });
  }, [mutateAsync]);
};
